import { __assign, __rest } from "tslib";
import * as React from 'react';
export var SearchBox = function (_a) {
    var input = _a.input, onSearch = _a.onSearch, children = _a.children, props = __rest(_a, ["input", "onSearch", "children"]);
    var search = React.useCallback(function (e) { return onSearch === null || onSearch === void 0 ? void 0 : onSearch(e.target.value); }, [onSearch]);
    return (React.createElement("div", { className: "search-container" },
        React.createElement("input", __assign({}, props, { type: "search", placeholder: "Search ...", value: input, onChange: search })),
        React.createElement("i", { className: "fas fa-search" }),
        children));
};
//# sourceMappingURL=index.js.map